module.exports = __webpack_public_path__ + "static/img/线下活动-快闪店.209ba8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-快闪店.png
// module id = piaG
// module chunks = 1